module.exports = __webpack_public_path__ + "static/showreel-7919d29d853a2558d81f6b66fd31bbc3.mp4";